import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import PasswordResetPage from './PasswordResetPage';

type TParams = { id: string, url: string }

function PasswordReset({ match }: RouteComponentProps<TParams>) {
    return (
        <Switch>
            <Route exact path={`${match.url}`} component={PasswordResetPage} />
        </Switch>
    );
}

export default PasswordReset;
